import './category.style.sass';
import template from './category.tpl.pug';

class CategoryController {
    /* @ngInject */
    constructor() {
    }

    $onChanges(changeObject) {
        if (changeObject.name) {
            let name = changeObject.name.currentValue;
            this.name = name || 'Unknown';
            this.unknown = !name;
        }

        if (changeObject.color || changeObject.fill) {
            this.borderColor = this.fill ? null : this.color;
            this.backgroundColor = this.fill ? this.color : null;
            this.iconColor = this.fill ? '#fff' : this.color;
        }

        if (changeObject.useIcons || changeObject.iconName || changeObject.iconIndex || changeObject.fallbackIconName) {
            this.iconNameResolved = this.iconName || this.fallbackIconName || null;
            this.showIcon = !!(this.useIcons && (this.iconNameResolved || this.iconIndex));
        }
    }
}

export default {
    selector: 'dbACategory',
    template: template(),
    controller: CategoryController,
    bindings: {
        name: '<',
        color: '<',
        fill: '<',
        disabled: '<',
        iconName: '<',
        iconIndex: '<',
        useIcons: '<',
        fallbackIconName: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category/category.cmpt.js